import introImageUrl from '../../design/grafik/Intro.png?url';
import mapImageUrl from '../../design/grafik/Kort.png?url';

export const visualAssets = {
  intro: introImageUrl,
  map: mapImageUrl,
} as const;
